import { Accordion, AccordionSummary, AccordionDetails, Card, CardMedia, Typography, Paper } from '@mui/material';
import BaseModal from "../baseModal";
import styled from "styled-components";
import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DataGrid } from '@mui/x-data-grid';


const StyledPaper = styled(Paper)(() => ({
    backgroundColor: 'transparent',
    height: "100%",
    width: "100%",
    borderTopLeftRadius: '15px',
    borderTopRightRadius: '15px',
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px'
}))

const StyledAccordion = styled(Accordion)(() => ({
    marginTop: '1rem',
    backgroundColor: 'transparent',
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px'
}))

const StyleAccordionSummary = styled(AccordionSummary)(() => ({
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px',
    backgroundImage: 'linear-gradient(to right, #F7931A , #6444fe)'
}))

const StyledExpandMoreIcon = styled(ExpandMoreIcon)(() => ({
    color: 'white'
}))

// const styledAccordionDetails = styled('div')(() => ({
//     display: 'flex'
// }))

const columns = [
    { field: 'id', headerName: '', width: 150 },
    { field: 'value', headerName: '', width: 250 },
];

const NftPreviewModal = ({ show, close, imageUrl, id, meta }) => {
    const [expanded, setExpanded] = useState(false);

    function handleAccordionToggle() {
        setExpanded(!expanded);
    }

    return (
        <BaseModal show={show} handleClose={close} >
            <StyledPaper>
                <Card
                    sx={{ height: '100%', width: '100%', backgroundColor: 'rgba(255, 255, 255, 0)', borderTopLeftRadius: '15px', borderTopRightRadius: '15px', borderBottomLeftRadius: '15px', borderBottomRightRadius: '15px' }}
                >
                    <CardMedia
                        component="img"
                        alt="Sample Image"
                        sx={{ height: '50%', width: '100%', objectFit: 'cover' }}
                        image={imageUrl}
                    />
                    <Typography variant="body2" className="nft-card-text">
                        #{id}
                    </Typography>
                    <StyledAccordion expanded={expanded} onChange={() => handleAccordionToggle()}>
                        <StyleAccordionSummary expandIcon={<StyledExpandMoreIcon />} >
                            <Typography variant="h6" color={'white'}>Attributes</Typography>
                        </StyleAccordionSummary>
                        <AccordionDetails>
                            <styledAccordionDetails>
                                <div style={{ height: '100%', width: '100%' }}>
                                    <div style={{ height: '400px', width: '100%' }}>
                                        {
                                            meta && <DataGrid
                                                rows={meta}
                                                columns={columns}
                                                pageSize={5}
                                                rowsPerPageOptions={[5, 10, 20]}
                                                hideFooter
                                                disableColumnFilter={true}
                                                disableColumnMenu={true}
                                                disableColumnSelector={true}
                                                columnHeaderHeight={0}
                                                scrollbarSize={0}
                                            />
                                        }
                                    </div>
                                </div>
                            </styledAccordionDetails>
                        </AccordionDetails>
                    </StyledAccordion>
                </Card>
            </StyledPaper>
        </BaseModal>
    )
}

export default NftPreviewModal;